export const ADS_TABLE = 'ads-table';
export const ADS_TOTALS = 'ads-table-totals';
export const ADS_TRENDS = 'ads-time-series';

export const SEO_TABLE = 'seo-report-table';
export const SEO_TOTALS = 'seo-report-table-totals';
export const SEO_TRENDS = 'seo-trends-time-series';

export const TRUEVIEW_TABLE = 'trueview-report-table';
export const TRUEVIEW_TOTALS = 'trueview-report-table-totals';
export const TRUEVIEW_TRENDS = 'trueview-trends';

export const SOURCES_TABLE = 'source-table';
export const SOURCES_TOTALS = 'source-table-totals';

export const OTT_TABLE = 'ott-report-table';
export const OTT_TOTALS = 'ott-report-table-totals';
export const OTT_TRENDS = 'ott-trends-time-series';
export const OTT_WIDGETS = 'ott-widgets';

export const JOURNEYS_TABLE = 'journeys-performance-table';
export const JOURNEYS_TOTALS = 'journeys-performance-table-totals';
export const JOURNEYS_TRENDS = 'journeys-time-series';

export const EMAILS_TABLE = 'email-performance-table';
export const EMAILS_TOTALS = 'email-performance-table-totals';
export const EMAILS_TRENDS = 'email-time-series';

export const SUMMARY_TABLE = 'summary-table';
export const SUMMARY_TOTALS = 'summary-table-totals';
export const SUMMARY_TRENDS = 'summary-time-series';

export const DISCO_DASHBOARD_TABLE = 'disco-dashboard';
export const DISCO_DASHBOARD_TOTALS = 'disco-dashboard-totals';

export const TABLE_TO_TOTALS_MAPPING = {
  [ADS_TABLE]: ADS_TOTALS,
  [SEO_TABLE]: SEO_TABLE,
  [TRUEVIEW_TABLE]: TRUEVIEW_TOTALS,
  [SOURCES_TABLE]: SOURCES_TOTALS,
  [JOURNEYS_TABLE]: JOURNEYS_TOTALS,
  [EMAILS_TABLE]: EMAILS_TOTALS,
  [SUMMARY_TABLE]: SUMMARY_TOTALS,
  [DISCO_DASHBOARD_TABLE]: DISCO_DASHBOARD_TABLE,
};
